import * as React from 'react'
import { ChevronDown } from 'lucide-react'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { Button } from '@/components/ui/button'
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible'

function initials(name: string) {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase()
}

/**
 * The profile photo as an avatar with an "Add photo" or "Change photo" toggle beside
 * it; the upload controls stay closed until staff asks for them.
 */
export function ProfilePhotoDisclosure({
  name,
  url,
  children,
}: {
  name: string
  url?: string | null
  children: React.ReactNode
}) {
  const [open, setOpen] = React.useState(false)

  return (
    <Collapsible open={open} onOpenChange={setOpen} className="group/photo mb-6 max-w-2xl">
      <div className="flex items-center gap-3">
        <Avatar className="size-12">
          {url && <AvatarImage src={url} alt="" />}
          <AvatarFallback className="text-body-sm">{initials(name)}</AvatarFallback>
        </Avatar>
        <CollapsibleTrigger asChild>
          <Button type="button" variant="outline" size="sm">
            {url ? 'Change photo' : 'Add photo'}
            <ChevronDown
              className="ml-1.5 size-4 transition-transform group-data-[state=open]/photo:rotate-180 motion-reduce:transition-none"
              strokeWidth={1.5}
              aria-hidden="true"
            />
          </Button>
        </CollapsibleTrigger>
      </div>
      <CollapsibleContent className="pt-4">{children}</CollapsibleContent>
    </Collapsible>
  )
}
